export function getBirthday(birthday?: string) {
  if (!birthday) {
    return undefined;
  }
  let result = birthday.split('/');
  if (result.length < 3) {
    return result;
  }
  result.shift();
  return result.join('/');
}
